//actions icons
import IconAnalytics from "./eewc_icons_actions/IconAnalytics.vue";
import IconArrowDown from "./eewc_icons_actions/IconArrowDown.vue";
import IconArrowLeft from "./eewc_icons_actions/IconArrowLeft.vue";
import IconArrowRight from "./eewc_icons_actions/IconArrowRight.vue";
import IconArrowUp from "./eewc_icons_actions/IconArrowUp.vue";
import IconCollapse from "./eewc_icons_actions/IconCollapse.vue";
import IconAttention from "./eewc_icons_actions/IconAttention.vue";
import IconAudit from "./eewc_icons_actions/IconAudit.vue";
import IconBookmark from "./eewc_icons_actions/IconBookmark.vue";
import IconBookmarkFilled from "./eewc_icons_actions/IconBookmarkFilled.vue";
import IconCalendar from "./eewc_icons_actions/IconCalendar.vue";
import IconCheck from "./eewc_icons_actions/IconCheck.vue";
import IconCheckZero from "./eewc_icons_actions/IconCheckZero.vue";
import IconClose from "./eewc_icons_actions/IconClose.vue";
import IconDelete from "./eewc_icons_actions/IconDelete.vue";
import IconDisable from "./eewc_icons_actions/IconDisable.vue";
import IconDownload from "./eewc_icons_actions/IconDownload.vue";
import IconDragAndDrop from "./eewc_icons_actions/IconDragAndDrop.vue";
import IconEdit from "./eewc_icons_actions/IconEdit.vue";
import IconEmail from "./eewc_icons_actions/IconEmail.vue";
import IconFilter from "./eewc_icons_actions/IconFilter.vue";
import IconFullSize from "./eewc_icons_actions/IconFullSize.vue";
import IconHelp from "./eewc_icons_actions/IconHelp.vue";
import IconHistory from "./eewc_icons_actions/IconHistory.vue";
import IconInfo from "./eewc_icons_actions/IconInfo.vue";
import IconLock from "./eewc_icons_actions/IconLock.vue";
import IconLogout from "./eewc_icons_actions/IconLogout.vue";
import IconMenuAndroid from "./eewc_icons_actions/IconMenuAndroid.vue";
import IconMinus from "./eewc_icons_actions/IconMinus.vue";
import IconMoreVert from "./eewc_icons_actions/IconMoreVert.vue";
import IconNotification from "./eewc_icons_actions/IconNotification.vue";
import IconNotificationNew from "./eewc_icons_actions/IconNotificationNew.vue";
import IconOpen from "./eewc_icons_actions/IconOpen.vue";
import IconPause from "./eewc_icons_actions/IconPause.vue";
import IconPlay from "./eewc_icons_actions/IconPlay.vue";
import IconPlus from "./eewc_icons_actions/IconPlus.vue";
import IconPtz from "./eewc_icons_actions/IconPtz.vue";
import IconResize from "./eewc_icons_actions/IconResize.vue";
import IconSavedOff from "./eewc_icons_actions/IconSavedOff.vue";
import IconSavedOn from "./eewc_icons_actions/IconSavedOn.vue";
import IconSearch from "./eewc_icons_actions/IconSearch.vue";
import IconSend from "./eewc_icons_actions/IconSend.vue";
import IconSettings from "./eewc_icons_actions/IconSettings.vue";
import IconShare from "./eewc_icons_actions/IconShare.vue";
import IconSnapshot from "./eewc_icons_actions/IconSnapshot.vue";
import IconSort from "./eewc_icons_actions/IconSort.vue";
import IconSound from "./eewc_icons_actions/IconSound.vue";
import IconSoundOff from "./eewc_icons_actions/IconSoundOff.vue";
import IconTrim from "./eewc_icons_actions/IconTrim.vue";
import IconViewMode from "./eewc_icons_actions/IconViewMode.vue";
import IconVpn from "./eewc_icons_actions/IconVpn.vue";
import IconArticle from "./eewc_icons_actions/IconArticle.vue";
import IconFeedback from "./eewc_icons_actions/IconFeedback.vue";
import IconContactSupport from "./eewc_icons_actions/IconContactSupport.vue";
import IconPhone from "./eewc_icons_actions/IconPhone.vue";
import IconStop from "./eewc_icons_actions/IconStop.vue";
import IconAvailableDevice from "./eewc_icons_actions/IconAvailableDevice.vue";
import IconFramePrevious from './eewc_icons_actions/IconFramePrevious.vue';
import IconFrameNext from './eewc_icons_actions/IconFrameNext.vue';
import IconSkipPrevious from './eewc_icons_actions/IconSkipPrevious.vue';
import IconSkipNext from './eewc_icons_actions/IconSkipNext.vue';
import IconCopy from './eewc_icons_actions/IconCopy.vue';
import IconHierarchy from './eewc_icons_actions/IconHierarchy.vue';
import IconShared from './eewc_icons_actions/IconShared.vue';
import IconMarkUnread from './eewc_icons_actions/IconMarkUnread.vue';
import IconZoomIn from './eewc_icons_actions/IconZoomIn.vue';
import IconZoomOut from './eewc_icons_actions/IconZoomOut.vue';
import Icon10SecAfter from './eewc_icons_actions/Icon10SecAfter.vue';
import Icon10SecBefore from './eewc_icons_actions/Icon10SecBefore.vue';
import IconKeyFrameNext from './eewc_icons_actions/IconKeyFrameNext.vue';
import IconKeyFramePrevious from './eewc_icons_actions/IconKeyFramePrevious.vue';
import IconNext from './eewc_icons_actions/IconNext.vue';
import IconPrevious from './eewc_icons_actions/IconPrevious.vue';
import IconVideoNext from './eewc_icons_actions/IconVideoNext.vue';
import IconVideoPrevious from './eewc_icons_actions/IconVideoPrevious.vue';
import IconEventNext from './eewc_icons_actions/IconEventNext.vue';
import IconEventPrevious from './eewc_icons_actions/IconEventPrevious.vue';
import IconEye from "./eewc_icons_actions/IconEye.vue";
import IconAddLayout from "./eewc_icons_actions/IconAddLayout.vue";
import IconTriangle from "./eewc_icons_actions/IconTriangle.vue";
import IconFunnel from "./eewc_icons_actions/IconFunnel.vue";
import IconOrders from "./eewc_icons_actions/IconOrders.vue";
import IconQuotes from "./eewc_icons_actions/IconQuotes.vue";
import IconContacts from "./eewc_icons_actions/IconContacts.vue";
import IconTransactions from "./eewc_icons_actions/IconTransactions.vue";
import IconProducts from "./eewc_icons_actions/IconProducts.vue";
import IconPayment from "./eewc_icons_actions/IconPayment.vue";
import IconRestart from "./eewc_icons_actions/IconRestart.vue";
import IconVideoSearch from "./eewc_icons_actions/IconVideoSearch.vue";
import IconCopyContent from "./eewc_icons_actions/IconCopyContent.vue";
import IconSpeed1X from "./eewc_icons_actions/IconSpeed1X.vue";
import IconSpeed2X from "./eewc_icons_actions/IconSpeed2X.vue";
import IconSpeed4X from "./eewc_icons_actions/IconSpeed4X.vue";
import IconSpeed8X from "./eewc_icons_actions/IconSpeed8X.vue";
import IconSpeedZeroPoint5X from "./eewc_icons_actions/IconSpeedZeroPoint5X.vue";
import IconYoutube from "./eewc_icons_actions/IconYoutube.vue";
import IconExternalLink from "./eewc_icons_actions/IconExternalLink.vue";
import IconManual from "./eewc_icons_actions/IconManual.vue";

// empty states
import IconEmptyBridges from "./eewc_icons_empty_state/IconEmptyBridges.vue";
import IconEmptyCameras from "./eewc_icons_empty_state/IconEmptyCameras.vue";
import IconEmptyEvents from "./eewc_icons_empty_state/IconEmptyEvents.vue";
import IconEmptySwitches from "./eewc_icons_empty_state/IconEmptySwitches.vue";
import IconEmptyLocations from "./eewc_icons_empty_state/IconEmptyLocations.vue";
import iconOfflineVideo from "./eewc_icons_empty_state/iconOfflineVideo.vue"
import IconEmptyNotifications from "./eewc_icons_empty_state/IconEmptyNotifications.vue"
import IconEmptyResults from "./eewc_icons_empty_state/IconEmptyResults.vue";
import IconEmptyFilter from "./eewc_icons_empty_state/IconEmptyFilter.vue";
import IconEmptyFloor from "./eewc_icons_empty_state/IconEmptyFloor.vue";
import IconEmptyAuditLogs from "./eewc_icons_empty_state/IconEmptyAuditLogs.vue";
import IconEmptyCalendar from "./eewc_icons_empty_state/IconEmptyCalendar.vue";
import IconWorkInProgress from "./eewc_icons_empty_state/IconWorkInProgress.vue";
import IconEmptyUsers from "./eewc_icons_empty_state/IconEmptyUsers.vue";
import IconEmptyTrustedDevices from "./eewc_icons_empty_state/IconEmptyTrustedDevices.vue";
import IconAccessDenied from "./eewc_icons_empty_state/IconAccessDenied.vue";
import IconEmptyPage from "./eewc_icons_empty_state/IconEmptyPage.vue";
import IconEmptySearchResult from "./eewc_icons_empty_state/IconEmptySearchResult.vue";
import IconNewLayout from "./eewc_icons_empty_state/IconNewLayout.vue";
import IconEmptyArchive from "./eewc_icons_empty_state/IconEmptyArchive.vue";
import IconEmptySpeakers from "./eewc_icons_empty_state/IconEmptySpeakers.vue"

// selection controls
import IconCheckBoxOn from "./eewc_icons_selection_controls/IconCheckboxOn.vue";
import IconCheckboxOnFocus from "./eewc_icons_selection_controls/IconCheckboxOnFocus.vue";
import IconCheckBoxOff from "./eewc_icons_selection_controls/IconCheckboxOff.vue";
// import IconCheckboxOffFocus from "./eewc_icons_selection_controls/IconCheckboxOffFocus.vue";
import IconCheckBoxindeterminate from "./eewc_icons_selection_controls/IconCheckboxindeterminate.vue";
import IconCheckboxindeterminateFocus from "./eewc_icons_selection_controls/IconCheckboxindeterminateFocus.vue";

// status icons
import IconArchive from "./eewc_icons_status/IconArchive.vue";
import IconAvailable from "./eewc_icons_status/IconAvailable.vue";
import IconBodycam from "./eewc_icons_status/IconBodycam.vue";
import IconBridge from "./eewc_icons_status/IconBridge.vue";
import IconBulb from "./eewc_icons_status/IconBulb.vue";
import IconCamera from "./eewc_icons_status/IconCamera.vue";
import IconCards from "./eewc_icons_status/IconCards.vue";
import IconDashboard from "./eewc_icons_status/IconDashboard.vue";
import IconDealer from "./eewc_icons_status/IconDealer.vue";
import IconDoor from "./eewc_icons_status/IconDoor.vue";
import IconFisheye from "./eewc_icons_status/IconFisheye.vue";
import IconInteroffline from "./eewc_icons_status/IconInteroffline.vue";
import IconUnavailable from "./eewc_icons_status/IconUnavailable.vue";
import IconLayouts from "./eewc_icons_status/IconLayouts.vue";
import IconList from "./eewc_icons_status/IconList.vue";
import IconLive from "./eewc_icons_status/IconLive.vue";
import IconLocation from "./eewc_icons_status/IconLocation.vue";
import IconMap from "./eewc_icons_status/IconMap.vue";
import IconMicro from "./eewc_icons_status/IconMicro.vue";
import IconOff from "./eewc_icons_status/IconOff.vue";
import IconOffline from "./eewc_icons_status/IconOffline.vue";
import IconOnline from "./eewc_icons_status/IconOnline.vue";
import IconPano from "./eewc_icons_status/IconPano.vue";
import IconSignal from "./eewc_icons_status/IconSignal.vue";
import IconSingle from "./eewc_icons_status/IconSingle.vue";
import IconSiren from "./eewc_icons_status/IconSiren.vue";
import IconSwitch from "./eewc_icons_status/IconSwitch.vue";
import IconTags from "./eewc_icons_status/IconTags.vue";
import IconUser from "./eewc_icons_status/IconUser.vue";
import IconUsers from "./eewc_icons_status/IconUsers.vue";
import IconWeb from "./eewc_icons_status/IconWeb.vue";
import IconNoInternet from "./eewc_icons_status/IconNoInternet.vue";
import IconViewColumn from "./eewc_icons_status/IconViewColumn.vue";
import IconDoubleColumn from "./eewc_icons_status/IconDoubleColumn.vue";
import IconVideo from './eewc_icons_status/IconVideo.vue';
import IconFolder from './eewc_icons_status/IconFolder.vue';
import IconBigFolder from './eewc_icons_status/IconBigFolder.vue';
import IconImage from './eewc_icons_status/IconImage.vue';
import IconUnread from './eewc_icons_actions/IconUnread.vue';
import IconSecurity from './eewc_icons_status/IconSecurity.vue';
import IconJob from './eewc_icons_status/IconJob.vue';
import IconNotificationAudit from './eewc_icons_status/IconNotificationAudit.vue';
import IconOperational from './eewc_icons_status/IconOperational.vue';
import IconNotificationHealth from './eewc_icons_status/IconNotificationHealth.vue';
import FloorplanSearch from './eewc_icons_status/IconFloorplan.vue';
import IconVsp from './eewc_icons_status/IconVsp.vue';
import IconCameraDirect from './eewc_icons_status/IconCameraDirect.vue'
import IconTampering from "./eewc_icons_status/IconTampering.vue";
import IconLoitering from "./eewc_icons_status/IconLoitering.vue";
import IconIntrusion from "./eewc_icons_status/IconIntrusion.vue";
import IconLineCrossing from "./eewc_icons_status/IconLineCrossing.vue";
import IconAnalyticsDown from "./eewc_icons_status/IconAnalyticsDown.vue";
import IconAnalyticsUp from "./eewc_icons_status/IconAnalyticsUp.vue";
import IconAnalyticsTriangle from "./eewc_icons_status/IconAnalyticsTriangle.vue";
import IconMultiCamera from "./eewc_icons_status/IconMultiCamera.vue";
import IconAnalyticsIn from "./eewc_icons_status/IconAnalyticsIn.vue";
import IconAnalyticsOut from "./eewc_icons_status/IconAnalyticsOut.vue";
import IconAddCamera from "./eewc_icons_actions/IconAddCamera.vue";
import IconNoPermissions from "./eewc_icons_status/IconNoPermissions.vue";
import IconClock from "./eewc_icons_status/IconClock.vue";
import IconFOV45 from "./eewc_icons_status/IconFOV45.vue";
import IconFOV360 from "./eewc_icons_status/IconFOV360.vue";
import IconTablet from "./eewc_icons_status/IconTablet.vue";
import IconLaptop from "./eewc_icons_status/IconLaptop.vue";
import IconMobile from "./eewc_icons_status/IconMobile.vue";
import IconCelebration from "./eewc_icons_status/IconCelebration.vue";
import IconLoading from "./eewc_icons_status/IconLoading.vue";
import IconPreview from "./eewc_icons_status/IconPreview.vue";
import IconEmptyActions from "./eewc_icons_actions/IconEmptyActions.vue";
import IconFileHTML from "./eewc_icons_status/IconFileHTML.vue";
import IconFileCSV from "./eewc_icons_status/IconFileCSV.vue";
import IconPower from "./eewc_icons_status/IconPower.vue";
import IconPos from "./eewc_icons_status/IconPos.vue";
import IconSync from "./eewc_icons_actions/IconSync.vue";

export const actionIcons = {
    icon_copy: {
        component: IconCopy
    },
    icon_zoom_in: {
        component: IconZoomIn
    },
    icon_zoom_out: {
        component: IconZoomOut
    },
    icon_shared: {
        component: IconShared
    },
    icon_hierarchy: {
        component: IconHierarchy
    },
    icon_analytics: {
        component: IconAnalytics
    },
    icon_available_devices: {
        component: IconAvailableDevice
    },
    icon_article: {
        component: IconArticle
    },
    icon_feedback: {
        component: IconFeedback
    },
    icon_contact_support: {
        component: IconContactSupport
    },
    icon_phone: {
        component: IconPhone
    },
    icon_arrow_down: {
        component: IconArrowDown
    },
    icon_arrow_left: {
        component: IconArrowLeft
    },
    icon_arrow_right: {
        component: IconArrowRight
    },
    icon_arrow_up: {
        component: IconArrowUp
    },
    icon_attention: {
        component: IconAttention
    },
    icon_audit: {
        component: IconAudit
    },
    icon_bookmark: {
        component: IconBookmark
    },
    icon_bookmark_filled: {
        component: IconBookmarkFilled
    },
    icon_calendar: {
        component: IconCalendar
    },
    icon_check: {
        component: IconCheck
    },
    icon_check_zero: {
        component: IconCheckZero
    },
    icon_close: {
        component: IconClose
    },
    icon_delete: {
        component: IconDelete
    },
    icon_disable: {
        component: IconDisable
    },
    icon_download: {
        component: IconDownload
    },
    icon_drag_and_drop: {
        component: IconDragAndDrop
    },
    icon_edit: {
        component: IconEdit
    },
    icon_email: {
        component: IconEmail
    },
    icon_filter: {
        component: IconFilter
    },
    icon_full_size: {
        component: IconFullSize
    },
    icon_help: {
        component: IconHelp
    },
    icon_history: {
        component: IconHistory
    },
    icon_info: {
        component: IconInfo
    },
    icon_lock: {
        component: IconLock
    },
    icon_logout: {
        component: IconLogout
    },
    icon_menu_android: {
        component: IconMenuAndroid
    },
    icon_minus: {
        component: IconMinus
    },
    icon_more_vert: {
        component: IconMoreVert
    },
    icon_notification: {
        component: IconNotification
    },
    icon_notification_new: {
        component: IconNotificationNew
    },
    icon_open: {
        component: IconOpen
    },
    icon_pause: {
        component: IconPause
    },
    icon_play: {
        component: IconPlay
    },
    icon_plus: {
        component: IconPlus
    },
    icon_ptz: {
        component: IconPtz
    },
    icon_resize: {
        component: IconResize
    },
    icon_savedoff: {
        component: IconSavedOff
    },
    icon_savedon: {
        component: IconSavedOn
    },
    icon_search: {
        component: IconSearch
    },
    icon_send: {
        component: IconSend
    },
    icon_settings: {
        component: IconSettings
    },
    icon_share: {
        component: IconShare
    },
    icon_snapshot: {
        component: IconSnapshot
    },
    icon_sort: {
        component: IconSort
    },
    icon_sound: {
        component: IconSound
    },
    icon_sound_off: {
        component: IconSoundOff
    },
    icon_trim: {
        component: IconTrim
    },
    icon_view_mode: {
        component: IconViewMode
    },
    icon_vpn: {
        component: IconVpn
    },
    icon_stop: {
        component: IconStop
    },
    icon_frame_previous: {
        component: IconFramePrevious
    },
    icon_frame_next: {
        component: IconFrameNext
    },
    icon_skip_previous: {
        component: IconSkipPrevious
    },
    icon_skip_next: {
        component: IconSkipNext
    },
    icon_mark_unread: {
        component: IconMarkUnread
    },
    icon_10_sec_before: {
        component: Icon10SecBefore
    },
    icon_10_sec_after: {
        component: Icon10SecAfter
    },
    icon_keyframe_next: {
        component: IconKeyFrameNext
    },
    icon_keyframe_previous: {
        component: IconKeyFramePrevious
    },
    icon_next: {
        component: IconNext
    },
    icon_previous: {
        component: IconPrevious
    },
    icon_video_next: {
        component: IconVideoNext
    },
    icon_video_previous: {
        component: IconVideoPrevious
    },
    icon_event_next: {
        component: IconEventNext
    },
    icon_event_previous: {
        component: IconEventPrevious
    },
    icon_eye: {
        component: IconEye
    },
    icon_add_camera: {
        component: IconAddCamera
    },
    icon_add_layout: {
        component: IconAddLayout
    },
    icon_triangle: {
        component: IconTriangle
    },
    icon_funnel: {
        component: IconFunnel
    },
    icon_orders: {
        component: IconOrders
    },
    icon_quotes: {
        component: IconQuotes
    },
    icon_contacts: {
        component: IconContacts
    },
    icon_transactions: {
        component: IconTransactions
    },
    icon_products: {
        component: IconProducts
    },
    icon_payment: {
        component: IconPayment
    },
    icon_restart: {
        component: IconRestart
    },
    icon_video_search: {
        component: IconVideoSearch
    },
    icon_copy_content: {
        component: IconCopyContent
    },
    icon_speed_1X: {
        component: IconSpeed1X
    },
    icon_speed_2X: {
        component: IconSpeed2X
    },
    icon_speed_4X: {
        component: IconSpeed4X
    },
    icon_speed_8X: {
        component: IconSpeed8X
    },
    icon_speed_zero_point_5X: {
        component: IconSpeedZeroPoint5X
    },
    icon_youtube: {
        component: IconYoutube
    },
    icon_external_link: {
        component: IconExternalLink
    },
    icon_manual: {
        component: IconManual
    },
    icon_sync: {
        component: IconSync
    },
    icon_collapse: {
        component: IconCollapse
    }
}

export const statusIcons = {
    icon_archive: {
        component: IconArchive
    },
    icon_available: {
        component: IconAvailable
    },
    icon_bigfolder: {
        component: IconBigFolder
    },
    icon_body_cam: {
        component: IconBodycam
    },
    icon_bridge: {
        component: IconBridge
    },
    icon_bulb: {
        component: IconBulb
    },
    icon_camera: {
        component: IconCamera
    },
    icon_cards: {
        component: IconCards
    },
    icon_dashboard: {
        component: IconDashboard
    },
    icon_dealer: {
        component: IconDealer
    },
    icon_door: {
        component: IconDoor
    },
    icon_fisheye: {
        component: IconFisheye
    },
    icon_folder: {
        component: IconFolder
    },

    icon_internet_offline: {
        component: IconInteroffline
    },
    icon_layouts: {
        component: IconLayouts
    },
    icon_list: {
        component: IconList
    },
    icon_live: {
        component: IconLive
    },
    icon_location: {
        component: IconLocation
    },
    icon_map: {
        component: IconMap
    },
    icon_micro: {
        component: IconMicro
    },
    icon_off: {
        component: IconOff
    },
    icon_offline: {
        component: IconOffline
    },
    icon_online: {
        component: IconOnline
    },
    icon_pano: {
        component: IconPano
    },
    icon_signal: {
        component: IconSignal
    },
    icon_single: {
        component: IconSingle
    },
    icon_siren: {
        component: IconSiren
    },
    icon_switch: {
        component: IconSwitch
    },
    icon_tags: {
        component: IconTags
    },
    icon_user: {
        component: IconUser
    },
    icon_users: {
        component: IconUsers
    },
    icon_web: {
        component: IconWeb
    },
    icon_no_internet: {
        component: IconNoInternet
    },
    icon_view_column: {
        component: IconViewColumn
    },
    icon_double_column: {
        component: IconDoubleColumn
    },
    icon_video: {
        component: IconVideo
    },
    icon_image: {
        component: IconImage
    },
    icon_unread: {
        component: IconUnread
    },
    icon_notification_audit: {
        component: IconNotificationAudit
    },
    icon_security: {
        component: IconSecurity
    },
    icon_operational: {
        component: IconOperational
    },
    icon_job: {
        component: IconJob
    },
    icon_notification_health: {
        component: IconNotificationHealth
    },
    icon_floorplan: {
        component: FloorplanSearch
    },
    icon_unavailable: {
        component: IconUnavailable
    },
    icon_vsp: {
        component: IconVsp
    },
    icon_tampering: {
        component: IconTampering
    },
    icon_loitering: {
        component: IconLoitering
    },
    icon_intrusion: {
        component: IconIntrusion
    },
    icon_line_crossing: {
        component: IconLineCrossing
    },
    icon_analytics_down: {
        component: IconAnalyticsDown
    },
    icon_analytics_up: {
        component: IconAnalyticsUp
    },
    icon_analytics_triangle: {
        component: IconAnalyticsTriangle
    },
    icon_multi_camera: {
        component: IconMultiCamera
    },
    icon_analytics_in: {
        component: IconAnalyticsIn
    },
    icon_analytics_out: {
        component: IconAnalyticsOut
    },
    icon_camera_direct: {
        component: IconCameraDirect
    },
    icon_no_permissions: {
        component: IconNoPermissions
    },
    icon_clock: {
        component: IconClock
    },
    icon_FOV_45: {
        component: IconFOV45
    },
    icon_FOV_360: {
        component: IconFOV360
    },
    icon_laptop: {
        component: IconLaptop
    },
    icon_mobile: {
        component: IconMobile
    },
    icon_tablet: {
        component: IconTablet
    },
    icon_celebration: {
        component: IconCelebration
    },
    icon_loading: {
        component: IconLoading
    },
    icon_preview: {
        component: IconPreview
    },
    icon_file_html: {
        component: IconFileHTML
    },
    icon_file_csv: {
        component: IconFileCSV
    },
    icon_power: {
        component: IconPower
    },
    icon_pos: {
        component: IconPos
    }
}

export const selectionControlsIcons = {
    icon_checkboxOn: {
        component: IconCheckBoxOn
    },
    icon_checkboxOff: {
        component: IconCheckBoxOff
    },
    icon_checkBoxindeterminate: {
        component: IconCheckBoxindeterminate
    },
    icon_checkboxOffFocus: {
        component: IconCheckboxOnFocus
    },
    icon_checkboxOnFocus: {
        component: IconCheckboxOnFocus
    },
    icon_checkBoxindeterminateFocus: {
        component: IconCheckboxindeterminateFocus
    }
}

export const emptyStateIcons = {
    icon_empty_bridges: {
        component: IconEmptyBridges
    },
    icon_empty_cameras: {
        component: IconEmptyCameras
    },
    icon_empty_events: {
        component: IconEmptyEvents
    },
    icon_empty_filter: {
        component: IconEmptyFilter
    },
    icon_empty_switches: {
        component: IconEmptySwitches
    },
    icon_empty_locations: {
        component: IconEmptyLocations
    },
    icon_offline_video: {
        component: iconOfflineVideo
    },
    icon_empty_notifications: {
        component: IconEmptyNotifications
    },
    icon_empty_results: {
        component: IconEmptyResults
    },
    icon_empty_floor: {
        component: IconEmptyFloor
    },
    icon_empty_audit_logs: {
        component: IconEmptyAuditLogs
    },
    icon_empty_calendar: {
      component: IconEmptyCalendar
    },
    icon_work_in_progress: {
        component: IconWorkInProgress
    },
    icon_empty_users: {
        component: IconEmptyUsers
    },
    icon_empty_trusted_devices: {
        component: IconEmptyTrustedDevices
    },
    icon_access_denied: {
        component: IconAccessDenied
    },
    icon_empty_page: {
        component: IconEmptyPage
    },
    icon_empty_search_result: {
        component: IconEmptySearchResult
    },
    icon_new_layout: {
        component: IconNewLayout
    },
    icon_empty_archive: {
        component: IconEmptyArchive
    },
    icon_empty_actions: {
        component: IconEmptyActions
    },
    icon_empty_speakers: {
        component: IconEmptySpeakers
    }
}
export const icons = { values: { ...actionIcons, ...statusIcons, ...selectionControlsIcons, ...emptyStateIcons } }
